import { render, staticRenderFns } from "./LoginHistoryTable.vue?vue&type=template&id=9da544a2&"
import script from "./LoginHistoryTable.vue?vue&type=script&lang=js&"
export * from "./LoginHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VDataTable,VFadeTransition})
